// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lxZ0EemgJBgCS0OZ{white-space:pre-wrap}.mVUilh4dAQgMRcJO{max-width:100%}.yOZAqc91PVQH5pl9 li{list-style-type:decimal;margin-left:calc(1em + 4px)}.pKt2df3XPgIRvuCQ li{list-style-type:disc;margin-left:calc(1em + 4px)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"lineBreak": `lxZ0EemgJBgCS0OZ`,
	"markdownReader": `mVUilh4dAQgMRcJO`,
	"ol": `yOZAqc91PVQH5pl9`,
	"ul": `pKt2df3XPgIRvuCQ`
};
export default ___CSS_LOADER_EXPORT___;
